/* eslint-disable no-extend-native */
import { defineNuxtPlugin } from '#app'
import numeral from 'numeral'

declare global {
  interface Number {
    separatePrice: () => string
  }
}

Number.prototype.separatePrice = function (): string {
  return numeral(this).format('0,0')
}

export default defineNuxtPlugin((nuxtApp) => {})
